<template>
    <div class="schedule modal" @click="outsideClick()">   
        <loading-screen v-if="loadingScreen" />
        <div class="schedule modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="schedule modal-body">
              <template v-if="!success">
                <div class="text">
                  <p>Preencha os campos a seguir e agende a coleta do seu KIT.</p>
                  <h4>Dados para coleta</h4>
                </div>
                <form @submit="handleSubmit" class="form">
                <div class="input-box">
                  <label for="zip" :class="{'has-error': errors && errors.zip_code}">CEP *</label>
                  <input
                      type="text"
                      name="zip"
                      id="zip"
                      v-mask="'#####-###'"
                      @blur="findAddress"
                      v-model="form.zip_code" />
              <small class="error" v-if="errors && errors.zip_code">{{errors.zip_code.join()}}</small>
              </div>
              <div class="input-box sm">
                  <label for="address" :class="{'has-error': errors && errors.address}">Logradouro *</label>
                  <input
                      type="text"
                      name="address"
                      id="address"
                      v-model="form.address" />
              <small class="error" v-if="errors && errors.address">{{errors.address.join()}}</small>
              </div>
              <div class="input-box sm">
                  <label for="address" :class="{'has-error': errors && errors.neighbourhood}">Bairro *</label>
                  <input
                      type="text"
                      name="neighbourhood"
                      id="neighbourhood"
                      v-model="form.neighbourhood" />
              <small class="error" v-if="errors && errors.neighbourhood">{{errors.neighbourhood.join()}}</small>
              </div>
              <div class="input-box sm">
                  <label for="number" :class="{'has-error': errors && errors.number}">Número *</label>
                  <input
                      type="text"
                      name="number"
                      id="number"
                      v-model="form.number" />
              <small class="error" v-if="errors && errors.number">{{errors.number.join()}}</small>
              </div>
              <div class="input-box sm">
                  <label for="address">Complemento</label>
                  <input
                      type="text"
                      name="complement"
                      id="complement"
                      v-model="form.complement" />
              </div>
              <div class="input-box sm">
                  <label for="address" :class="{'has-error': errors && errors.city}">Cidade *</label>
                  <input
                      type="text"
                      name="city"
                      id="city"
                      v-model="form.city_name"
                      disabled />
              <small class="error" v-if="errors && errors.city">{{errors.city.join()}}</small>
              </div>
              <div class="input-box sm" :style="{'margin-bottom: 1.7rem' : !!turns}">
                  <label for="state" :class="{'has-error': errors && errors.state}">Estado *</label>
                  <input
                      type="text"
                      name="state"
                      id="state"
                      v-model="form.state_name"
                      disabled />
              <small class="error" v-if="errors && errors.state">{{errors.state.join()}}</small>
              </div>
              <div class="input-box sm" v-if="turns">
                  <label class="datepicker-label" for="birthdate" :class="{'has-error': errors && errors.schedule}">Escolha a Data *</label>
                  <select
                      name="schedule"
                      id="schedule"
                      @change="handleOnScheduleChange($event.target)">
                      <option value=null>Selecione uma opção</option>
                      <option v-for="(turn, key) in turns" v-bind:key="key" :value="key">
                          {{turn.day}} - {{turn.turn}} das {{turn.start_time}} às {{turn.end_time}}
                      </option>
                  </select>
                  <small class="error" v-if="errors && errors.schedule">{{errors.schedule.join()}}</small>
              </div>
              <div class="" v-if="notFound">
                  <span>
                      Ops!! Infelizmente o local indicado ainda não faz parte da área de cobertura para coleta.
                      Indique um local em Porto Alegre/RS.
                  </span>
              </div>
              <div class="form-actions" v-if="!notFound">
                <button class="button btn-primary" v-if="!loading" @click="handleSubmit">Agendar</button>
                <button class="button btn-primary" v-if="loading" @click="handleSubmit" disabled><loading /></button>
              </div>
                </form>
              </template>
              <template v-if="success">
                <div class="text">
                  <div class="text">
                    <h5>Parabéns!</h5>
                    <p>Agendamento realizado com sucesso e em breve você receberá os resultados.</p>
                    <div class="image">
                      <img src="@/assets/images/vector-fluxo-healthid-lab-moto.png">
                    </div>
                    <div class="form-actions">
                      <button class="button btn-primary" @click="$emit('close')">Voltar para meus Check-Ups</button>
                    </div>
                  </div>
                </div>
              </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { POST_SCHEDULE } from "../../services/schedule";
    import { ADDRESS_FIND } from '../../services/address'
    import { CITY_TIME } from '../../services/address'

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'vue2-datepicker/locale/pt-br';
    import moment from 'moment';

    export default {
        components: {  },
        props: {
          kit_id: null,
          kit_number: null,
        },
        data() {
            return {
              loading: false,
              loadingScreen: false,
              notFound: false,
		          turns: false,
              form: {},
              errors: [],
              success: false,
            }
        },
        methods: {
          outsideClick() {
            if(event.target === event.currentTarget && !this.loadingScreen)
                  this.$emit('close');
          },
          clearErrors() {
            this.errors = [];
          },
          async findAddress() {
            this.clearErrors();
            if(this.form.zip_code.length === 9){
              this.notFound = false;
              this.loadingScreen = true;
              const response = await ADDRESS_FIND(this.form.zip_code);
              if(response && response.logradouro){
                this.form.address = response.logradouro;
                this.form.city_name = response.localidade;
                this.form.neighbourhood = response.bairro;
                const response2 = await CITY_TIME(response.uf, response.localidade);
                if(response2){
                  this.form.state_id = response2.state_id;
                  this.form.state_name = response2.state;
                  this.form.city_id = response2.city_id;
                  this.form.city_name = response2.city;
                  this.turns = response2.turns
                }
              }else{
                this.errors.zip_code = ["CEP não encontrado."];
                this.form.address = null;
                this.form.city_name = null;
                this.form.state_id = null;
                this.form.state_name = null;
                this.form.city_id = null;
                this.turns = null;
              }
              this.loadingScreen = false;
            }
          },
          handleOnScheduleChange({value}) {
            if(this.turns[value]){
              this.form.schedule = this.turns[value];
              this.form.schedule_date = this.turns[value].full_date;
            }else{
              this.form.schedule = {};
            }
          },
          handleSubmit(event) {
            event.preventDefault();
            this.clearErrors();
            this.loading = true;
            let kit_number = this.kit_number;
            const form = { kit_number, ...this.form };
            POST_SCHEDULE(form).then(
              resp => {
                this.$emit('updateKit', this.kit_number);
                this.success = true;
              },
                  error => this.errors = error.response.data,
              ).then(
                resp => {
                  this.loading = false;
                }
              );
          },
        },
        mounted() {
          
        }
    }
</script>

<style scoped>
    .schedule .modal-box {
        max-height: 600px;
    }
    .schedule .modal-body {
        max-width: 500px;
        width: 500px;
        overflow-y: auto;
    }
    .schedule .modal-body .form {
      padding: 0 10px;
    }
    .schedule .modal-body .image {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
    }
    .schedule .modal-body img {
        width: 60%;
    }
</style>



// WEBPACK FOOTER //
// src/components/ScheduleModal/ScheduleModal.vue